import React from 'react';
import {Box, Grid, Skeleton} from '@mui/material';
const skeltonBorder10Margin10Style: React.CSSProperties = {borderRadius: '10px', marginBottom: '10px'};
const skeltonBorder10Margin5Style: React.CSSProperties = {borderRadius: '10px', marginBottom: '5px'};
const skeltonBorder10Style: React.CSSProperties = {borderRadius: '10px'};
export const BoardItemDialogSkeleton = () => {
    return (
        <>
            <Grid container padding={'20px'} spacing={1}>
                <Grid item xs={6}>
                    <Box>
                        <Skeleton style={skeltonBorder10Style} variant="rectangular" height={50} width="30%" />
                    </Box>
                </Grid>
                <Grid item xs={6}>
                    <Box display="flex" justifyContent="flex-end">
                        <Skeleton
                            style={{borderRadius: '10px', marginRight: '10px'}}
                            variant="rectangular"
                            height={50}
                            width="20%"
                        />
                        <Skeleton style={skeltonBorder10Style} variant="rectangular" height={37} width="6%" />
                    </Box>
                </Grid>
                <Grid item xs={11.6}>
                    <Box>
                        <Skeleton style={skeltonBorder10Margin10Style} variant="rectangular" height={50} width="100%" />
                        <Skeleton style={skeltonBorder10Margin10Style} variant="rectangular" height={40} width="100%" />
                        <Skeleton
                            style={skeltonBorder10Margin10Style}
                            variant="rectangular"
                            height={250}
                            width="100%"
                        />
                        <Skeleton style={skeltonBorder10Margin10Style} variant="rectangular" height={40} width="100%" />
                        <Skeleton style={skeltonBorder10Style} variant="rectangular" height={250} width="100%" />
                    </Box>
                </Grid>
                <Grid item xs={0.4}>
                    <Box>
                        <Skeleton style={skeltonBorder10Margin5Style} variant="rectangular" height={1} width="100%" />
                        <Skeleton style={skeltonBorder10Margin5Style} variant="rectangular" height={35} width="100%" />
                        <Skeleton style={skeltonBorder10Margin5Style} variant="rectangular" height={1} width="100%" />
                        <Skeleton style={skeltonBorder10Margin5Style} variant="rectangular" height={35} width="100%" />
                    </Box>
                </Grid>
            </Grid>
        </>
    );
};

export default BoardItemDialogSkeleton;
